// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_47-2";
export var blackBorderOnHover = "_47-7";
export var cell = "_47-6";
export var cellContainer = "_47-3";
export var checked = "_47-8";
export var disabled = "_47-5";
export var featuredIconCellContainer = "_47-9";
export var featuredIconTextContainer = "_47-b";
export var featuredIconWrapper = "_47-a";
export var noBorder = "_47-c";
export var orangeSelectedRow = "_c7-3";
export var overflowableText = "_47-0";
export var overflowableTextContainer = "_47-1";
export var row = "_44-0";
export var rowCheckboxCell = "_47-4";
export var selectableTable = "_c7-2";